import { Eye } from 'react-bytesize-icons';
import * as React from 'react';
export default {
  Eye,
  React
};